
import { Component, Mixins, Prop } from 'vue-property-decorator'
import IconsMixin from '../mixins/IconsMixin.vue'

@Component({name: 'navbar-item'})
export default class NavbarItem extends Mixins(IconsMixin) {
  @Prop()
  public navItem: any
}
